import { render, staticRenderFns } from "./rankContent.vue?vue&type=template&id=be759bce"
import script from "./rankContent.vue?vue&type=script&lang=js"
export * from "./rankContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports